import { render, staticRenderFns } from "./SyntheticRevenueReport.vue?vue&type=template&id=df71d050"
import script from "./SyntheticRevenueReport.vue?vue&type=script&lang=js"
export * from "./SyntheticRevenueReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports